import { InstagramMessageType } from "@jugl-web/rest-api";
import { InstagramMessageModel } from "@jugl-web/rest-api/integrations/models/InstagramMessage/InstagramMessageModel";

export const isInstagramMessageSupported = (message: InstagramMessageModel) =>
  "message" in message.payload &&
  !("is_unsupported" in message.payload.message) &&
  "msg_type" in message &&
  Object.values(InstagramMessageType).includes(message.msg_type);
